module.exports = __webpack_public_path__ + "static/media/PNB_F1.46561903.txt";